import { ActionField, AsyncField, Field, useFormContext } from '@oscar/form';
import {
  Button,
  Col,
  DatePicker,
  Icon,
  Input,
  Row,
  Select,
} from '@oscar/theme';
import { ReadOnlyInput, TextField } from 'common/components';
import { AddedFormProps } from 'common/components/FormList/types';
import { FORMAT_DATE } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import { getDateCorrect } from 'features/insulation/utils';
import { debounce } from 'lodash';
import moment from 'moment';

import '../style.scss';

const { TextArea } = Input;
const { Option } = Select;
interface Props {
  handleActiveCreateForm: (value: boolean) => void;
  [name: string]: any;
}

const Text = ({ value }: { value?: string }) => {
  return <div>{value}</div>;
};

const CreateForm = (props: AddedFormProps) => {
  const { field, addItem, removeItem } = props;
  const [formContext] = useFormContext();
  if (!field) {
    return <div>Empty</div>;
  }
  const disableStartdDate = (current: any) => {
    const { endDate } =
      formContext.form?.getFieldValue('listScaffoldDetail')[field!.key];
    if (endDate) {
      return (
        (current && current.isAfter(getDateCorrect(endDate))) ||
        current.isBefore(moment(), 'day')
      );
    }
    return current && current.isBefore(moment(), 'day');
  };
  const disableEndDate = (current: any) => {
    const { startDate } =
      formContext.form?.getFieldValue('listScaffoldDetail')[field!.key];
    if (startDate && getDateCorrect(startDate).isAfter(moment(), 'day')) {
      return current && current.isBefore(getDateCorrect(startDate), 'day');
    } else {
      return current && current.isBefore(moment(), 'day');
    }
  };
  const handleChangeStartDate = (e: any) => {
    const listScaffoldDetail =
      formContext.form?.getFieldValue('listScaffoldDetail');
    const { endDate } = listScaffoldDetail[field!.key];
    if (endDate && e > endDate) {
      const newListScaffoldDetail = [...listScaffoldDetail];
      newListScaffoldDetail[field!.key]['endDate'] = undefined;
      formContext?.form?.setFieldsValue({
        listScaffoldDetail: newListScaffoldDetail,
      });
    }
  };
  return (
    <div key={field!.key}>
      <div className="notification-detail">
        <div className="notification-detail-title">Search Result</div>
        <div className="notification-detail-content">
          <Row>
            <Col span={24}>
              <div className="search-header">
                <div className="search-header_id">
                  <div className="label-bold ">SiSFolds ID</div>
                  <Field
                    name={[field!.name, 'steelId']}
                    fieldKey={[field!.fieldKey, 'steelId']}
                  >
                    <Text />
                  </Field>
                </div>
                <div>
                  <ActionField name="subForm" request={{ name: 'test' }}>
                    {(subProps: any) => (
                      <>
                        <Button
                          size="small"
                          type="primary"
                          className="reset-button"
                          onClick={() => {
                            removeItem?.(field);
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          size="small"
                          type="primary"
                          onClick={() => {
                            addItem?.(field);
                          }}
                        >
                          Create
                        </Button>
                      </>
                    )}
                  </ActionField>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {/* <p className="label-normal">Status</p> */}
              <Field
                {...field}
                name={[field!.name, 'status']}
                fieldKey={[field!.fieldKey, 'status']}
              >
                <TextField
                  label="Status"
                  mappingData={SAP_STATUS_LIST}
                  primary
                />
              </Field>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <p className="label-normal">Job Description</p>
              <Field
                {...field}
                name={[field!.name, 'jobDescription']}
                fieldKey={[field!.fieldKey, 'jobDescription']}
              >
                <TextArea
                  className="form-job-description"
                  placeholder="Lorem ipsum dolor sit amet..."
                  autoSize={{ minRows: 2, maxRows: 2 }}
                />
              </Field>
            </Col>
          </Row>
          <AsyncField
            name={'fetchLocation'}
            requests={[
              {
                name: 'location',
                url: APIS.SEARCH_LOCATION,
                method: 'GET',
                nextParams: (nextProps: any) => {
                  return {
                    limit: 5,
                    functionalLocation: nextProps?.customData?.textSearch || '',
                  };
                },
              },
            ]}
          >
            {(locationProps: any) => {
              const options = locationProps?.data?.location || [];
              const textSearch =
                locationProps?.requests?.[0]?.params?.functionalLocation || '';
              return (
                <Row gutter={15}>
                  <Col span={12}>
                    <p className="label-normal">Functional Location</p>

                    <Field
                      {...field}
                      name={[field!.fieldKey, 'saP_FunctionalLocation']}
                      fieldKey={[field!.fieldKey, 'saP_FunctionalLocation']}
                    >
                      <Select
                        value={textSearch}
                        showSearch
                        suffixIcon={<Icon icon="search" size={18} />}
                        className="select-search"
                        placeholder="Search Functional Location"
                        allowClear
                        filterOption={false}
                        onSearch={debounce(value => {
                          locationProps.reloadData({ textSearch: value });
                        }, 300)}
                      >
                        {options.map?.((item: any) => {
                          return (
                            <Option value={item.id} key={item.id}>
                              {item.functionalLocation}
                            </Option>
                          );
                        })}
                      </Select>
                    </Field>
                  </Col>
                  <Col span={12}>
                    <p className="label-normal">Location Description</p>
                    <Field
                      name={[field!.name, 'saP_FunctionalLocation']}
                      fieldKey={[field!.fieldKey, 'saP_FunctionalLocation']}
                    >
                      <ReadOnlyInput textField="description" data={options} />
                    </Field>
                  </Col>
                </Row>
              );
            }}
          </AsyncField>
          <Row gutter={15}>
            <Col span={12}>
              <p className="label-normal">Start Date</p>
              <Field
                name={[field!.name, 'startDate']}
                fieldKey={[field!.fieldKey, 'startDate']}
              >
                <DatePicker
                  className="date-picker"
                  format={FORMAT_DATE.SHORT_MONTH_DATE}
                  disabledDate={disableStartdDate}
                  onChange={handleChangeStartDate}
                  inputReadOnly
                />
              </Field>
            </Col>
            <Col span={12}>
              <p className="label-normal">End Date</p>
              <Field
                name={[field!.name, 'endDate']}
                fieldKey={[field!.fieldKey, 'endDate']}
                dependencies={['listScaffoldDetail', field!.name, 'startDate']}
              >
                <DatePicker
                  className="date-picker"
                  format={FORMAT_DATE.SHORT_MONTH_DATE}
                  disabledDate={disableEndDate}
                  inputReadOnly
                />
              </Field>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CreateForm;
